<template>
  <ValidationObserver v-slot="{ handleSubmit, failed }" class="login__box" tag="div">
    <div class="login__box__welcome"></div>

    <div class="login__box__input-description">Username</div>
    <form @submit.prevent="handleSubmit(submitForm)">
      <ValidationProvider
        v-if="isEditing"
        rules="required"
        v-slot="{ failed, failedRules }"
      >
        <input
          v-model="form.username"
          type="text"
          class="login__box__input-email"
          :class="{ error: failed }"
          placeholder="username"
          :disabled="!isEditing"
        />
        <p class="validate-warn" v-if="failedRules.englishAlpha">
          {{ failedRules.englishAlpha }}
        </p>
      </ValidationProvider>

      <div class="login__box__input-description">Password</div>
      <ValidationProvider v-if="isEditing" rules="required" v-slot="{ failed }">
        <input
          v-model="form.password"
          type="password"
          class="login__box__input-password"
          :class="{ error: failed }"
          placeholder="password"
          :disabled="!isEditing"
        />
      </ValidationProvider>
      <div class="login__box__forgot-password">
        <span @click="forgotPassword()">Forgot password </span>
      </div>

      <router-link to="/register">
        <div class="login__box__register">
          <button type="button">Register</button>
        </div>
      </router-link>

      <div class="login__box__login" :class="{ disabled: failed }">
        <button class="button">Login</button>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "LoginBox",
  data() {
    return {
      editMode: false,
      form:
        process.env.NODE_ENV === "development"
          ? {
              username: "admin",
              password: "KrutoHusťáckýHesloNeŽádný1234!",
            }
          : {
              username: "",
              password: "",
            },
    };
  },
  methods: {
    ...mapActions({ signIn: "signIn" }),

    checkEmptyForm() {
      if (this.form.username == "" || this.form.password == "") {
        this.$toast.error(this.$t("messages.user-account.login-empty-fields"));
        this.form.password = "";
        return false;
      }
      return true;
    },
    isEditing() {
      return this.editMode;
    },

    async submitForm() {
      if (!this.checkEmptyForm()) return false;

      await this.$store.dispatch("toggleLoader", true);
      try {
        await this.signIn(this.form);
        this.$router.push({ name: "Join" });
      } catch (e) {
        this.form.password = "";
        this.$toast.error(this.$t("messages.auth.login-failed"));
      }
      await this.$store.dispatch("toggleLoader", false);
    },

    forgotPassword() {
      this.$emit("forgotPassword");
    },
  },
};
</script>

<style></style>
